module.exports = __webpack_public_path__ + "./docs/img/big-icon-protocol.1ac86d7178ae5a43706779ea4ad6c407.svg";